const PaginationArrow = ({ isRotated }) => {
  return (
    <svg
      width="6"
      height="8"
      viewBox="0 0 6 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{
        transform: isRotated ? 'rotate(180deg)' : 'rotate(0deg)',
      }}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.23094 0.184136C5.46061 0.422999 5.45317 0.802824 5.2143 1.0325L2.0641 4L5.2143 6.9675C5.45316 7.19718 5.46061 7.577 5.23094 7.81587C5.00126 8.05473 4.62143 8.06218 4.38257 7.8325L0.782571 4.4325C0.664923 4.31938 0.598436 4.16321 0.598436 4C0.598436 3.83679 0.664924 3.68062 0.782571 3.5675L4.38257 0.167501C4.62143 -0.0621752 5.00126 -0.0547276 5.23094 0.184136Z"
        fill="#121212"
      />
    </svg>
  );
};

export default PaginationArrow;
